// extracted by mini-css-extract-plugin
export var container = "SponsorCard-module--container--1qxOR";
export var visible = "SponsorCard-module--visible--1Ekvc";
export var image = "SponsorCard-module--image--EBcCx";
export var grade = "SponsorCard-module--grade--3_iYi";
export var name = "SponsorCard-module--name--2HcaR";